import { Pool } from "../../Utils/Collections/Pool";
import { Stadium } from "../Stadium/Stadium";
import { RoundManager } from "../Round/RoundManager";
import { Defender } from "./Defender";
import { DefenderCollision } from "./DefenderCollision";
import { NumValBase } from "../../Utils/NumberValue";



export class DefenderManager {
    /**
     * Mezera mezi jednotlivymi obranci
     */
    static readonly DEFENDERS_SPACING = 0.05;

    private _freeDefenders: Pool<Defender>;
    private _actDefenders: Defender[] = [];

    private _collision: DefenderCollision;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        this._freeDefenders = new Pool<Defender>(Defender, 4, true);
        this._collision = new DefenderCollision();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(): void {
        let i: number;
        let rndMng = RoundManager.instance;
        let rndSettings = rndMng.roundSetup;
        let defenderCnt = 0;
        let blockSettings = rndSettings.defenderSettings;

        if (blockSettings && (blockSettings.sizeRatio instanceof NumValBase ? blockSettings.sizeRatio.getValue() : blockSettings.sizeRatio) > 0) {
            let blockPos = NumValBase.getValue(blockSettings.pos);

            if (rndSettings.flippedHorizontally)
                blockPos = -blockPos;

            // Velikost blokovane casti v radianech
            let blockSizeAngle = (rndSettings.goalRSideAngle - rndSettings.goalLSideAngle) * NumValBase.getValue(blockSettings.sizeRatio);

            // Uhel do stredu blokovane casti vyhledu        
            let blockAngle = pc.math.lerp(rndSettings.goalLSideAngle + blockSizeAngle / 2, rndSettings.goalRSideAngle - blockSizeAngle / 2, (blockPos + 1) / 2);

            // Celkova vzdalenost od kick off pozice do brany ve smeru stredu blokovane casti
            let kickOffPos = rndSettings.kickOffPos;
            let intersectX = kickOffPos.x;

            if (blockAngle != -Math.PI / 2)
                intersectX -= (rndSettings.kickOffPos.z - Stadium.END_Z) / (Math.sin(blockAngle) / Math.cos(blockAngle));

            // Vzdalenost obrancu od kick off pozice
            let blockDis: number;

            if (blockSettings.distanceRatio == undefined) {
                blockDis = 0.5;
            }
            else {
                blockDis = NumValBase.getValue(blockSettings.distanceRatio);
            }

            blockDis = Math.sqrt(Math.pow(kickOffPos.x - intersectX, 2) + Math.pow(kickOffPos.z - Stadium.END_Z, 2)) * blockDis;

            if (blockDis < 5.5)
                blockDis = 5.5;

            // Pozice stredu obrancu
            let blockCenterX = kickOffPos.x + Math.cos(blockAngle) * blockDis;
            let blockCenterZ = kickOffPos.z + Math.sin(blockAngle) * blockDis;

            // Zname vzdalenost od vykopnuti do stredu blokovane casti a velikost uhlu blokovane casti. Potrebujeme spocitat velikost blokovane casti v units
            // TOA -> tan(blockSizeAngle / 2) = blockSize / blockDis -> blockSize = blockDis * tan(blockSizeAngle / 2)
            let blockSize = blockDis * Math.tan(blockSizeAngle / 2) * 2;

            // Kolik obrancu potrebuju na pokryti celkove velikosti kryti vyhledu
            defenderCnt = Math.ceil((blockSize + DefenderManager.DEFENDERS_SPACING) / (Defender.SIZE.x + DefenderManager.DEFENDERS_SPACING));

            // Upravit velikost blokovane casti podle skutecneho poctu obrancu
            blockSize = (defenderCnt * Defender.SIZE.x) + (defenderCnt - 1) * DefenderManager.DEFENDERS_SPACING;

            if (blockSettings.minNumOfEntities != undefined && defenderCnt < (blockSettings.minNumOfEntities instanceof NumValBase ? blockSettings.minNumOfEntities.getValue() : blockSettings.minNumOfEntities))
                defenderCnt = NumValBase.getValue(blockSettings.minNumOfEntities);

            // Vektor pro pocitani pozice obrancu (obranci se umistuji zleva)
            let blockStepZ = Math.cos(blockAngle);
            let blockStepX = -Math.sin(blockAngle);

            // Pozice obrance nejvice vlevo
            let defenderX: number;
            let defenderZ: number;

            i = -(blockSize / 2) + Defender.SIZE.x / 2;
            defenderX = blockCenterX + i * blockStepX;
            defenderZ = blockCenterZ + i * blockStepZ;

            // Umistit obrance
            let defenderAngle = -(blockAngle * pc.math.RAD_TO_DEG) - 90;

            for (i = 0; i < defenderCnt; i++) {
                let defender: Defender;

                if (this._actDefenders.length > i) {
                    defender = this._actDefenders[i];
                }
                else {
                    defender = this._freeDefenders.getItem();
                    this._actDefenders.push(defender);
                }

                defender.activate(defenderX, defenderZ, defenderAngle);

                defenderX += blockStepX * (Defender.SIZE.x + DefenderManager.DEFENDERS_SPACING);
                defenderZ += blockStepZ * (Defender.SIZE.x + DefenderManager.DEFENDERS_SPACING);
            }

            // Kolize
            this._collision.init(blockCenterX, blockCenterZ, defenderAngle, defenderCnt);
        }
        else {
            this._collision.reset();
        }

        // Uvolnit obrance, kteri jsou navic
        if (this._actDefenders.length > defenderCnt) {
            i = this._actDefenders.length;

            while (i-- != defenderCnt) {
                let defender = this._actDefenders[i];

                defender.reset();
                this._freeDefenders.returnItem(defender);
            }

            this._actDefenders.length = defenderCnt;
        }
    }
}